import api from "./api";

export const getsPeriodoView = async (filters = {}) => {
    const response = await api.get('/Periodo/GetsPeriodoView?'
            + 'idFilial=' + (filters.idFilial == null ? 0 : filters.idFilial)
            + '&idTipoTerapia=' + (filters.idTipoTerapia == null ? 0 : filters.idTipoTerapia)
            + '&idEstadoApertura=' + (filters.idEstadoApertura == null ? 0 : filters.idEstadoApertura)
            + '&mesesHaciaAtras=' + (filters.mesesHaciaAtras == null ? 0 : filters.mesesHaciaAtras)
            + '&idEstado=' + (filters.idEstado == null ? "" : filters.idEstado)
        );

    return response.data.data;
}

export const annulPeriodo = (idPeriodo) =>
    api.post("/Periodo/AnnulPeriodo?idPeriodo=" + idPeriodo);

export const activePeriodo = (idPeriodo) =>
    api.post("/Periodo/ActivePeriodo?idPeriodo=" + idPeriodo);

export const addUpdatePeriodo = (dataPost) =>
    api.post("/Periodo/AddUpdatePeriodo", dataPost);
